import { createContext, useContext, useEffect, useState, ReactNode } from "react"

const ToggleFlagContext = createContext<boolean | null>(null)

export const ToggleFlagProvider = ({ children }: { children: ReactNode }) => {
    const [value, setValue] = useState(true)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setValue((v) => !v)
        }, 1000)

        return () => clearInterval(intervalId)
    }, [])

    return <ToggleFlagContext.Provider value={value}>{children}</ToggleFlagContext.Provider>
}

export const useToggleFlag = () => {
    const context = useContext(ToggleFlagContext)

    if (context === null) {
        throw new Error("useToggleFlag debe usarse dentro de ToggleFlagProvider")
    }

    return context
}
